export const UIEVENT_PAP = 'PAP'; // Kliknięciu w dodanie sugerowanego produktu na ekranie koszyka
export const UIEVENT_AVL = 'AVL'; // Dodanie notyfikacji o dostępność produktu
export const UIEVENT_ADD = 'ADD'; // Kliknięcie w dodanie produktu - #5264
export const UIEVENT_PLV = 'PLV'; // Wyświetlony produkt
export const UIEVENT_UIACT = 'UIACT'; // Wyświetlenie strony
export const UIEVENT_UIEXT = 'UIEXT'; // Wyświetlenie zewnętrznej strony (estebox) - #5226
